// Official recommendation, reference https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
export const base64url = (input: string): string => {
	const bytes = new TextEncoder().encode(input);
	const binString = String.fromCodePoint(...bytes);
	return window.btoa(binString).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
};

export const base64 = (input: string): string => {
	const bytes = new TextEncoder().encode(input);
	const binString = String.fromCodePoint(...bytes);
	return window.btoa(binString);
};
